<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $tc('labels.list', 0) }}</h3>
    </route-header>
    <div class="row">
      <div class="col-12">
        <list-items ref="lists" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ListView',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
